var exports = {
  "i": "x936d19a0--ba35f1--wrapper",
};

module.exports = exports;
